import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotAuthorized = ({ title, message }) => {
	const { t } = useTranslation();
	
	const defaultTitle = t('EULA_ADMIN.PERMISSION_DENIED');
	const defaultMessage = t('EULA_ADMIN.YOU_DO_NOT_HAVE_PERMISSION_TO_ACCESS_THIS_SECTION');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        textAlign: 'center',
        p: 4,
      }}
    >
      <Typography variant="h5" gutterBottom>
        {title || defaultTitle}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {message || defaultMessage}
      </Typography>
    </Box>
  );
};

export default NotAuthorized;

